import { render, staticRenderFns } from "./BaseReportSection.vue?vue&type=template&id=ef27840a&scoped=true&"
import script from "./BaseReportSection.vue?vue&type=script&lang=ts&"
export * from "./BaseReportSection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseReportSection.vue?vue&type=style&index=0&id=ef27840a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef27840a",
  null
  
)

export default component.exports